import './components/navbar.js';
import './components/tiny-slider.js';
import './components/typeform-block.js';

$('.menu-navbar__top-level__link[data-page="epargne"]').addClass('is-active');
var span = document.getElementsByClassName("current")[0];
var buttonPrev = document.getElementsByClassName("prev")[0];
var buttonNext = document.getElementsByClassName("next")[0];
const indicator1 = document.querySelector('.indicator-1');
const indicator2 = document.querySelector('.indicator-2');
const indicator3 = document.querySelector('.indicator-3');
indicator1.classList.add('active');
indicator2.classList.remove('active');
indicator3.classList.remove('active');
$(buttonPrev).on("click", function (e) {
    const spanInner = span.innerHTML.toString()
    if (  spanInner === '2 to 3' || spanInner === '1 to 3' || spanInner === '2') {
        indicator1.classList.add('active');
        indicator2.classList.remove('active');
        indicator3.classList.remove('active');
    }
    if ( spanInner === '3') {
        indicator2.classList.add('active');
        indicator3.classList.remove('active');
        indicator1.classList.remove('active');
    }
  });
  $(buttonNext).on("click", function (e) {
    const spanInner = span.innerHTML.toString();
    if (spanInner === '1 to 2' ||spanInner === '1 to 3' || spanInner === '2') {
        indicator3.classList.add('active');
        indicator2.classList.remove('active');
        indicator1.classList.remove('active');
    }
    if ( spanInner === '1') {
        indicator2.classList.add('active');
        indicator3.classList.remove('active');
        indicator1.classList.remove('active');
    }
  });


